import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import core from '@gin-betting/core';
import responsiveComponents from '@gin-betting/responsive-components';
import cn from 'classnames';
import { throttle } from 'lodash';

import { BreakpointSettings } from 'types';

import './rootResponse.scss';

interface Props {
    customBreakpoints?: BreakpointSettings;
}

const { useResponsiveContainer } = responsiveComponents;
const {
    viewport: {
        actions: { calculateResponsiveState },
    },
} = core;

// breakpoints should be equal $mq-breakpoints!
const breakpoints = {
    ['superExtraSmall']: 360,
    ['extraSmall']: 480,
    ['mediumExtraSmall']: 620,
    ['untilSmall']: 767,
    ['small']: 768,
    ['fromSmall']: 769,
    ['medium']: 1097,
    ['large']: 1348,
    ['great']: 1560,
    ['extralarge']: 1920,
    ['stream-XXS']: 900,
    ['stream-XS']: 1000,
    ['stream-S']: 1097,
    ['stream-M']: 1177,
    ['stream-L']: 1275,
    ['stream-XL']: 1348,
    ['stream-XXL']: 1495,
    ['stream-XXXL']: 1655,
    ['stream-XXXXL']: 1783,
    ['pinned-stream-S']: 1100,
    ['pinned-stream-M']: 1200,
    ['pinned-stream-L']: 1400,
    ['pinned-stream-XL']: 1600,
};

const RootResponse: React.FC<Props> = ({ children, customBreakpoints }) => {
    const dispatch = useDispatch();

    const {
        containerRef,
        currentBreakpoints,
        currentWidth,
    } = useResponsiveContainer({
        breakpoints: { ...breakpoints, ...customBreakpoints },
    });

    const throttled = useRef(
        throttle((innerWidth: number | null) => {
            if (!innerWidth) return;

            dispatch(calculateResponsiveState({ innerWidth }));
        }, 300)
    );

    useEffect(() => {
        throttled.current(currentWidth);
    }, [currentWidth]);

    return (
        <div
            ref={containerRef}
            styleName="container"
            className={cn(
                '__app-RootResponse-container ignore-mq',
                currentBreakpoints
            )}
        >
            {children}
        </div>
    );
};

export default RootResponse;
